
export const accordionInit = () => {
    const accordions = document.querySelectorAll('.accordion');
    accordions.forEach(acc => {
        const headers = acc.querySelectorAll('.accordion__header');
        headers.forEach(header => {
            // Set ARIA attributes for accessibility
            header.setAttribute("role", "button");
            header.setAttribute("tabindex", "0");
            header.setAttribute("aria-expanded", "false");
            const content = header.nextElementSibling;
            if (content) {
                content.style.overflow = "hidden";
                content.style.maxHeight = "0px";
                content.style.transition = "max-height 0.45s cubic-bezier(0.23, 1, 0.32, 1)";
            }

            header.addEventListener('click', function () {
                toggleAccordion(header, headers);
            });

            header.addEventListener("keydown", (event) => {
                if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    toggleAccordion(header, headers);
                }
            });
        });

        // Make the first item active by default
        if (headers.length > 0) {
            const firstHeader = headers[0];
            const firstContent = firstHeader.nextElementSibling;
            const firstItem = firstHeader.closest('.accordion__item');
            if (firstContent) {
                firstContent.style.maxHeight = firstContent.scrollHeight + "px";
                firstContent.classList.add("is-active");
            }
            firstHeader.classList.add("is-active");
            firstHeader.setAttribute("aria-expanded", "true");
            if (firstItem) {
                firstItem.classList.add("is-active");
            }
        }
    });

    
    function toggleAccordion(currentHeader, allHeaders) {
        const content = currentHeader.nextElementSibling;
        const isExpanding = !currentHeader.classList.contains("is-active");
        const currentItem = currentHeader.closest('.accordion__item');

        // Close all other accordions
        allHeaders.forEach(header => {
            if (header !== currentHeader) {
                const otherContent = header.nextElementSibling;
                const otherItem = header.closest('.accordion__item');
                if (otherContent) {
                    otherContent.style.maxHeight = "0px";
                    otherContent.classList.remove("is-active");
                }
                header.classList.remove("is-active");
                header.setAttribute("aria-expanded", "false");
                if (otherItem) {
                    otherItem.classList.remove("is-active");
                }
            }
        });

        // Toggle current accordion
        if (isExpanding) {
            if (content) {
                content.style.maxHeight = content.scrollHeight + "px";
                content.classList.add("is-active");
            }
            currentHeader.classList.add("is-active");
            currentHeader.setAttribute("aria-expanded", "true");
            if (currentItem) {
                currentItem.classList.add("is-active");
            }
        } else {
            if (content) {
                content.style.maxHeight = "0px";
                content.classList.remove("is-active");
            }
            currentHeader.classList.remove("is-active");
            currentHeader.setAttribute("aria-expanded", "false");
            if (currentItem) {
                currentItem.classList.remove("is-active");
            }
        }
    }
};
